import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import logo from "../assets/v.png";
export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  // This function handles the smooth scrolling for internal links
  const handleScroll = (e, targetId) => {
    e.preventDefault();
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      const navbarHeight = document.querySelector('nav').offsetHeight;
      const elementPosition = targetElement.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - navbarHeight;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    }
    setIsOpen(false);
  };
  
  const navLinkClassName = ({ isActive }) => {
    const baseClasses = "font-medium text-slate-800 hover:text-blue-600 transition duration-150 ease-in-out";
    return isActive ? `${baseClasses} text-blue-600` : baseClasses;
  };

const Logo = () => (
  <span className="inline-flex items-center space-x-2 font-bold  text-xl select-none">
    <img src={logo} alt="Vatsal Logo" className="h-6 w-auto" />
    <span className="uppercase tracking-widest">Vatsal</span>
  </span>
);

  return (
    <nav className="fixed w-full top-0 left-0 z-50 bg-[#F8F6F1] shadow-sm">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          
          <div className="flex-shrink-0">
            <NavLink to="/" onClick={(e) => handleScroll(e, 'home')}>
              <Logo />
            </NavLink>
          </div>

          <div className="hidden md:flex items-center space-x-10">
            <NavLink to="/#skills" className={navLinkClassName} onClick={(e) => handleScroll(e, 'skills')}>
              Skills
            </NavLink>
            <NavLink to="/#projects" className={navLinkClassName} onClick={(e) => handleScroll(e, 'projects')}>
              Projects
            </NavLink>
            <NavLink to="/#socials" className={navLinkClassName} onClick={(e) => handleScroll(e, 'socials')}>
              Socials
            </NavLink>
          </div>

          {/* --- CHANGE 1: DESKTOP BUTTON --- */}
          {/* Changed from NavLink to a standard <a> tag for the external link */}
          <div className="hidden md:block">
            <a
              href="https://calendly.com/koriyavatsal4/30min"
              target="_blank" // Opens the link in a new tab
              rel="noopener noreferrer" // Recommended for security
              className="px-6 py-3 text-sm font-bold text-white bg-slate-800 rounded-full hover:bg-slate-700 transition duration-150 ease-in-out"
            >
              Schedule a call
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              type="button"
              className="inline-flex items-center justify-center p-2 rounded-md text-slate-800 hover:text-blue-600 focus:outline-none"
              aria-controls="mobile-menu"
              aria-expanded={isOpen}
            >
              <span className="sr-only">Open main menu</span>
              <svg className="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                {isOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7" />
                )}
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-[#F8F6F1] border-t border-gray-200" id="mobile-menu">
          <div className="px-4 pt-4 pb-6 space-y-4">
            <NavLink to="/#skills" onClick={(e) => handleScroll(e, 'skills')} className="block font-medium text-slate-800">
              Skills
            </NavLink>
            <NavLink to="/#projects" onClick={(e) => handleScroll(e, 'projects')} className="block font-medium text-slate-800">
              Projects
            </NavLink>
            <NavLink to="/#socials" onClick={(e) => handleScroll(e, 'socials')} className="block font-medium text-slate-800">
              Socials
            </NavLink>

            {/* --- CHANGE 2: MOBILE BUTTON --- */}
            {/* Also changed this to a standard <a> tag */}
            <a
              href="https://calendly.com/koriyavatsal4/30min"
              target="_blank"
              rel="noopener noreferrer"
              className="block text-center mt-4 px-6 py-3 font-bold text-white bg-slate-800 rounded-full hover:bg-slate-700"
            >
              Schedule a call
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}